// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__KqX5F","content":"GlobalSearch_content__27RrO"};